import React from 'react';
import { Link } from 'react-router-dom';
import './style.scss';

const BoxNews = ({ item, tab }) => {

  return (
    <div className="box-news image-hover">
      <div className="box-news__img">
        <Link to={`/tinh-nang/tin-tuc?tab=${tab}&id=${item.NEWS_ID}`}>
          <img alt={item.GROUP_NAME} src={item.IMAGE} />
        </Link>
      </div>
      <div className="box-news__content">
        <Link to={`/tinh-nang/tin-tuc?tab=${tab}&id=${item.NEWS_ID}`}>
          <h4 title={item.TITLE}>{item.TITLE}</h4>
        </Link>
        <p dangerouslySetInnerHTML={{ __html: item.EN_DESCRIPTION || item.DATETIME }} className="box-news__des" />
      </div>
    </div>
  );
}

export default React.memo(BoxNews);
